import { Action } from '@ngrx/store';
import { Customer, CustomerFilter, CustomerUser, CustomerUserAccess, UserSearchFilter, UserInvitation } from '@model';

export enum CustomersActionTypes {
  CustomersLoadData = '[Customers] Load data',
  CustomersLoadSuccess = '[Customers] Load success',
  CustomersLoadFail = '[Customers] Load fail',

  CustomersSelect = '[Customers] Select',
  ClearSelectedCustomer = '[Customers] Clear selected customer',
  CustomersTabChanged = '[Customers] Tab changed',

  CustomersFilterLoadData = '[CustomersFilter] Load data',
  CustomersFilterLoadSuccess = '[CustomersFilter] Load success',
  CustomersFilterLoadFail = '[CustomersFilter] Load fail',

  CustomersFilterUpdate = '[CustomersFilter] Update filter',

  ClearCustomers = '[Customers] Clear customers',

  CustomersUserAccessLoadData = '[CustomersUserAccess] Load data',
  CustomersUserAccessLoadSuccess = '[CustomersUserAccess] Load success',
  CustomersUserAccessLoadFail = '[CustomersUserAccess] Load fail',
  ClearCustomersUserAccessData = '[CustomersUserAccess] Clear data',
  
  CustomersUserAccessSelection = '[CustomersUserAccess] Set Customer Selection',

  CustomersUsersLoadData = '[CustomersUsers] Load data',
  CustomersUsersLoadSuccess = '[CustomersUsers] Load success',
  CustomersUsersLoadFail = '[CustomersUsers] Load fail',

  UserLockUpdate = '[CustomersUsers] Locked users',

  CustomersUsersSelect = '[CustomersUsers] Select',

  SelectedCustomersUserAccessLoadData = '[CustomersUserAccess] Load selected user data',
  SelectedCustomersUserAccessLoadSuccess = '[CustomersUserAccess] Load selected user data success',
  SelectedCustomersUserAccessLoadFail = '[CustomersUserAccess] Load selected user data fail',
  ClearSelectedCustomersUserAccessData = '[CustomersUserAccess] Clear selected user data ',

  SelectedCustomersUserCustomerSelection = '[CustomersUserAccess] Set selected Users Customer Selection',

  CustomersUsersFilterLoadData = '[CustomersUsersFilter] Load data',
  CustomersUsersFilterLoadSuccess = '[CustomersUsersFilter] Load success',
  CustomersUsersFilterLoadFail = '[CustomersUsersFilter] Load fail',

  CustomersUsersFilterUpdate = '[CustomersUsersFilter] Update filter',

  CustomersExternalOrganisationsLoadData = '[CustomersExternalOrganisations] Load data',
  CustomersExternalOrganisationsLoadSuccess = '[CustomersExternalOrganisations] Load success',
  CustomersExternalOrganisationsLoadFail = '[CustomersExternalOrganisations] Load fail',
}

export class CustomersLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersLoadData;
  constructor() {}
}
export class CustomersLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersLoadSuccess;
  constructor(public payload: Customer[]) {}
}
export class CustomersLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersLoadFail;
  constructor(public payload: any) {}
}

export class CustomersSelect implements Action {
  readonly type = CustomersActionTypes.CustomersSelect;
  constructor(public payload: Customer) {}
}
export class ClearSelectedCustomer implements Action {
  readonly type = CustomersActionTypes.ClearSelectedCustomer;
  constructor() {}
}
export class CustomersTabChanged implements Action {
  readonly type = CustomersActionTypes.CustomersTabChanged;
  constructor(public payload: number) {}
}

export class CustomersFilterLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersFilterLoadData;
  constructor() {}
}
export class CustomersFilterLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersFilterLoadSuccess;
  constructor(public payload: CustomerFilter) {}
}
export class CustomersFilterLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersFilterLoadFail;
  constructor(public payload: any) {}
}
export class CustomersFilterUpdate implements Action {
  readonly type = CustomersActionTypes.CustomersFilterUpdate;
  constructor(public payload: CustomerFilter) {}
}

export class ClearCustomers implements Action {
  readonly type = CustomersActionTypes.ClearCustomers;
  constructor() {}
}

export class CustomersUserAccessLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersUserAccessLoadData;
  constructor() {}
}
export class CustomersUserAccessLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersUserAccessLoadSuccess;
  constructor(public payload: CustomerUserAccess[]) {}
}
export class CustomersUserAccessLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersUserAccessLoadFail;
  constructor(public payload: any) {}
}
export class CustomersUserAccessSelection implements Action {
  readonly type = CustomersActionTypes.CustomersUserAccessSelection;
  constructor(public payload: string[]) {}
}

export class ClearCustomersUserAccessData implements Action {
  readonly type = CustomersActionTypes.ClearCustomersUserAccessData;
  constructor() {}
}
export class CustomersUsersLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersUsersLoadData;
  constructor() {}
}
export class CustomersUsersLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersUsersLoadSuccess;
  constructor(public payload: CustomerUser[]) {}
}
export class CustomersUsersLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersUsersLoadFail;
  constructor(public payload: any) {}
}

export class UserLockUpdate implements Action {
  readonly type = CustomersActionTypes.UserLockUpdate;
  constructor(public payload: string[]) {}
}
export class CustomersUsersSelect implements Action {
  readonly type = CustomersActionTypes.CustomersUsersSelect;
  constructor(public payload: CustomerUser) {}
}
export class SelectedCustomersUserAccessLoadData implements Action {
  readonly type = CustomersActionTypes.SelectedCustomersUserAccessLoadData;
  constructor(public payload: string) {}
}
export class SelectedCustomersUserAccessLoadSuccess implements Action {
  readonly type = CustomersActionTypes.SelectedCustomersUserAccessLoadSuccess;
  constructor(public payload: CustomerUserAccess[]) {}
}
export class SelectedCustomersUserAccessLoadFail implements Action {
  readonly type = CustomersActionTypes.SelectedCustomersUserAccessLoadFail;
  constructor(public payload: any) {}
}
export class ClearSelectedCustomersUserAccessData implements Action {
  readonly type = CustomersActionTypes.ClearSelectedCustomersUserAccessData;
  constructor() {}
}
export class SelectedCustomersUserCustomerSelection implements Action {
  readonly type = CustomersActionTypes.SelectedCustomersUserCustomerSelection;
  constructor(public payload: string[]) {}
}

export class CustomersUsersFilterLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersUsersFilterLoadData;
  constructor() {}
}
export class CustomersUsersFilterLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersUsersFilterLoadSuccess;
  constructor(public payload: UserSearchFilter) {}
}
export class CustomersUsersFilterLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersUsersFilterLoadFail;
  constructor(public payload: any) {}
}
export class CustomersUsersFilterUpdate implements Action {
  readonly type = CustomersActionTypes.CustomersUsersFilterUpdate;
  constructor(public payload: UserSearchFilter) {}
}

// ExternalOrganisations
export class CustomersExternalOrganisationsLoadData implements Action {
  readonly type = CustomersActionTypes.CustomersExternalOrganisationsLoadData;
  constructor() {}
}
export class CustomersExternalOrganisationsLoadSuccess implements Action {
  readonly type = CustomersActionTypes.CustomersExternalOrganisationsLoadSuccess;
  constructor(public payload: UserInvitation[]) {}
}
export class CustomersExternalOrganisationsLoadFail implements Action {
  readonly type = CustomersActionTypes.CustomersExternalOrganisationsLoadFail;
  constructor(public payload: any) {}
}


export type CustomersActions =
  | CustomersLoadData
  | CustomersLoadSuccess
  | CustomersLoadFail
  | CustomersSelect
  | ClearSelectedCustomer
  | CustomersTabChanged
  | CustomersFilterLoadData
  | CustomersFilterLoadFail
  | CustomersFilterLoadSuccess
  | CustomersFilterUpdate
  | ClearCustomers
  | CustomersUserAccessLoadData
  | CustomersUserAccessLoadSuccess
  | CustomersUserAccessLoadFail
  | ClearCustomersUserAccessData
  | CustomersUserAccessSelection
  | CustomersUsersLoadData
  | CustomersUsersLoadSuccess
  | CustomersUsersLoadFail
  | CustomersUsersSelect
  | UserLockUpdate
  | SelectedCustomersUserAccessLoadData
  | SelectedCustomersUserAccessLoadSuccess
  | SelectedCustomersUserAccessLoadFail
  | ClearSelectedCustomersUserAccessData
  | SelectedCustomersUserCustomerSelection
  | CustomersUsersFilterLoadData
  | CustomersUsersFilterLoadFail
  | CustomersUsersFilterLoadSuccess
  | CustomersUsersFilterUpdate
  | CustomersExternalOrganisationsLoadData
  | CustomersExternalOrganisationsLoadSuccess
  | CustomersExternalOrganisationsLoadFail;
